import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily?: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      cardBoxOuterContainer: {
        width: '440px',
        marginBottom: '0px',
        [theme.breakpoints.down('lg')]: {
          width: '625px',
          paddingBottom: '0px'
        }
      },
      cardBoxContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
        textAlign: 'center',
        height: '500px',
        padding: '20px 24px',
        [theme.breakpoints.down('lg')]: {
          flexDirection: 'row',
          height: '375px',
          textAlign: 'end'
        }
      },
      cardBoxImage: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'transparent',
        width: '90%',
        height: '220px',
        [theme.breakpoints.down('lg')]: {
          width: '240px',
          height: '220px',
          marginRight: '20px'
        }
      },
      cardImage: {
        width: '100%',
        height: '100%',
        objectFit: 'contain'
      },
      cardDescriptionBox: {
        width: '360px',
        height: '230px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('lg')]: {
          height: '100%',
          width: '300px'
        }
      },
      cardDescText: {
        textAlign: 'center',
        fontSize: '30px',
        letterSpacing: 0,
        fontFamily: props.fontFamily,
        [theme.breakpoints.down('lg')]: {
          textAlign: 'left',
          fontSize: '38px'
        }
      }
    })
  );
